module.exports = __webpack_public_path__ + "static/media/Small-right.71c1b143.svg";